import React from 'react';

// import DefaultFallback from './fallback';

// import ErrorLogger from '../../utils/loggers';
// import type { IOptions } from '../../utils/loggers';

export type TErrorFallback = (
  location: string,
  error?: Error,
  errorInfo?: React.ErrorInfo,
  loggedErrors?: string[]
) => React.ReactNode;

export interface IProps {
  location: string;
}

export interface IState {
  hasError?: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
  loggedErrors?: string[];
}

class BzIconErrorBoundary extends React.Component<React.PropsWithChildren<IProps>, IState> {
  state: Readonly<IState> = {};

  static readonly defaultProps: Partial<IProps> = {};

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error: error
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    const { children, location } = this.props;
    const { error, errorInfo, loggedErrors } = this.state;

    if (!error) {
      return children;
    }

    return null; //<>{fallback?.(location, error, errorInfo, loggedErrors)}</>;
  }
}

export default BzIconErrorBoundary;
